module.exports = __webpack_public_path__ + "static/capitalFactoryLogo-3ff18ac03cd9ec66df766c1b590c82ad.png";